import { render, staticRenderFns } from "./formvehicle.vue?vue&type=template&id=444bd4b0&"
import script from "./formvehicle.vue?vue&type=script&lang=js&"
export * from "./formvehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports